import { useCallback } from "react";
import { authAxios } from "../axios";

export const usePasswordSearchAndRegister = () => {
  const [state, execute, cancel] = authAxios<void, { login: string }, unknown>({
    url: "/password/searchAndRegister",
    method: "POST",
  });

  const callback = useCallback(
    (email: string, params: Record<string, string>) => {
      return execute({
        params,
        data: {
          login: email,
        },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
